import React, { useState } from 'react'

import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

import { Button } from '..'
import { useChallenge, useUser } from '../../context'
import { ChallengeStatus, ChallengeWithStatus } from '../../types'
import { DeleteLogModal } from '../modal'

const ChallengeCardBtn = ({
  challenge,
  onClickFn,
}: {
  challenge: ChallengeWithStatus
  onClickFn: () => void
}) => {
  const navigate = useNavigate()
  const { userRole, setOnEditionMode } = useUser()
  const { removeChallenge, error: chaError } = useChallenge()

  const [showConfirmation, setShowConfirmation] = useState(false)
  const hideButton =
    userRole === 'student' && challenge.status === ChallengeStatus.ENDED

  const btnLabel = () => {
    if (userRole !== 'student') {
      return challenge.status === 'active'
        ? 'Agregar Participantes'
        : challenge.status === 'upcoming'
          ? 'Ver Desafío'
          : 'Ver resultados'
    } else {
      return challenge.status === 'active' ? 'Participar' : 'Ver más'
    }
  }

  const handleBtnAction = () => {
    if (userRole !== 'student') {
      setOnEditionMode(false)
      return navigate(`/desafios/${challenge.id}`, { state: { challenge } })
    } else {
      return onClickFn()
    }
  }

  const handleEdit = () => {
    setOnEditionMode(true)

    navigate(`/desafios/editar-desafio`, {
      state: { challenge },
    })
  }

  const handleRemove = async () => {
    if (!challenge.id) {
      return
    }
    try {
      await removeChallenge(challenge.id)
      toast.success('Desafío eliminado con exito')
    } catch (error) {
      console.error('Error al eliminar el desafio', error)
      toast.error(chaError)
    } finally {
      setOnEditionMode(false)
      navigate(`/desafios`)
    }
  }

  return (
    <>
      {showConfirmation && (
        <DeleteLogModal
          handleClose={() => setShowConfirmation(false)}
          handleDelete={handleRemove}
          message="¿Estas seguro@ que quieres eliminar el desafío?"
          hasButton
        />
      )}

      {!hideButton && (
        <Button
          className="active light-blue"
          onClick={handleBtnAction}
          fontSize={16}
          fontWeight={400}
          label={btnLabel()}
          width="100%"
        />
      )}
      {userRole === 'admin' && (
        <div className="actions-container">
          <Button
            className="light-blue"
            onClick={handleEdit}
            fontSize={16}
            fontWeight={400}
            width="50%"
            label="Editar"
          />

          <Button
            className="delete"
            onClick={() => setShowConfirmation(true)}
            fontSize={16}
            fontWeight={400}
            width="50%"
            label="Eliminar"
          />
        </div>
      )}
    </>
  )
}

export default ChallengeCardBtn
